import { createContext, useContext } from "react";
import _ from "lodash";

const TranscriptsContext = createContext(null);

export const TranscriptsProvider = TranscriptsContext.Provider;

export const useTranscriptsContext = () => {
  const context = useContext(TranscriptsContext);

  if (_.isNil(context)) {
    throw new Error(
      "useTranscriptsContext must be used within a TranscriptsProvider"
    );
  }

  return context;
};
